import React, { useState, useEffect } from "react";
import "./style.css";
import {useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { EditPostButton } from "../EditPostButton";
import { Dictionary } from "@onaio/utils/dist/types/types";
import { useAuth } from "react-oidc-context";
import { UserDropdown } from "../UserDropdown";
import { PostMenu } from "../PostMenu";
import { ShareOptions } from "../../Post/Share";
import "./style.css";

const GlobalNav = () => {
  const user = useSelector((store: Dictionary) => store.user);
  const post = useSelector((store: Dictionary) => store.post);
  const space = useSelector((store: Dictionary) => store.space);
  const location = useLocation<Dictionary>();
  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();

  const shouldShow = () => {
    if (location.pathname.includes("/edit")) {
      return false;
    }
    if (location.pathname.includes("/post/") && !post.uuid) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (shouldShow()) {
      document.body.classList.add("has-global-nav");
      return () => {
        document.body.classList.remove("has-global-nav");
      };
    }
  }, [isAuthenticated, post.uuid]);


  if (!shouldShow()) return null;

  if (space?.config?.isPublic) return null;

  return (
    <div className="global-nav">
      <PostMenu />
      {!isAuthenticated && (
        <p className="global-nav-prompt">
          Akuko is a platform for telling stories with data
        </p>
      )}
      <EditPostButton />
      {isAuthenticated && post.uuid && (
        <ShareOptions post={post} user={user} className="global-nav-share" />
      )}
      <UserDropdown />
    </div>
  );
};

export { GlobalNav };
